export default "__VITE_ASSET__yz1ZUqsm__"